import { render, staticRenderFns } from "./diff_stats_dropdown.vue?vue&type=template&id=9ec2068e&scoped=true"
import script from "./diff_stats_dropdown.vue?vue&type=script&lang=js"
export * from "./diff_stats_dropdown.vue?vue&type=script&lang=js"
import style0 from "./diff_stats_dropdown.vue?vue&type=style&index=0&id=9ec2068e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec2068e",
  null
  
)

export default component.exports